import React, { Component } from 'react';
import { InfoWindow, Marker } from 'react-google-maps';
import './MapMarker.css';
import * as itemHelper from '../../../../utils/ItemsHelper';
import { ROUTING, PATH } from '../../../../constants';

// todo - show some 'fetching' state?
class MapMarker extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isOpen: false,
    };

    this.toggleOpen = this.toggleOpen.bind(this);
  }

  toggleOpen() {
    this.setState(prevState => ({
      isOpen: !prevState.isOpen,
    }));
  }

  render() {
    const { markerData } = this.props;
    const look = itemHelper.getItemLook(markerData[1]);

    return (
      <Marker
        key={markerData[0]}
        icon={`${PATH.IMG}ico/ico-map-marker.png`}
        position={{ lat: markerData[1].gpsn, lng: markerData[1].gpse }}
        onClick={this.toggleOpen}
      >
        {this.state.isOpen &&
        <InfoWindow
          onCloseClick={this.toggleOpen}
        >
          <a className="mi-wrap" href={`#${ROUTING.DETAIL}/${markerData[0]}`}>
            <div className="mi-img-cont">
              <img className="mi-thumb" src={look.imgUrl} alt={markerData[1].title} />
              <img className="mi-ico" src={`${PATH.IMG}ico/ico-${look.ico}.png`} alt="Otevřít" />
            </div>
            <div className="mi-date">{markerData[1].timeline}</div>
            <div className="mi-title">{markerData[1].title}</div>
          </a>
        </InfoWindow>
        }
      </Marker>
    );
  }
}

export default MapMarker;



// WEBPACK FOOTER //
// ./src/components/App/Map/MapMarker/MapMarker.js